import clsx from 'clsx';
import { PhoneArrowUpRightIcon } from '@heroicons/react/24/outline';
import { useCallCentreWindow } from '../context/CallCentreWindowContext';
import { useAuth } from '../context/AuthContext';
import { canAccessTool, TOOL_KEYS } from '../config/toolAccess';
import { navActionButtonClass } from '../components/layout/navActionButton';

/**
 * Call Centre launcher in the top navbar.
 *
 * Shown only to roles that hold the Call Centre tool — a launcher that opens onto
 * "Access denied" is worse than no launcher. Follows Settings → Tool Access live.
 */
export default function CallCentreTaskbar({ className }) {
  const { user } = useAuth();
  const { open, restore, openCallCentre, stepLabel: step } = useCallCentreWindow();
  if (!canAccessTool(user?.role, TOOL_KEYS.CONTACT_CENTER_INTEL)) return null;

  const tooltip = open && step ? `Resume Call Centre · ${step}` : open ? 'Resume Call Centre' : 'Open Call Centre';
  return (
    <button
      type="button"
      onClick={() => (open ? restore() : openCallCentre())}
      aria-label={open ? 'Restore Call Centre' : 'Open Call Centre'}
      title={tooltip}
      className={clsx(navActionButtonClass({ active: open }), className)}
    >
      <PhoneArrowUpRightIcon className="h-4 w-4 shrink-0 text-teal-600" strokeWidth={2} />
      <span className="truncate max-w-[9rem]">Call Centre</span>
    </button>
  );
}
